import { render, staticRenderFns } from "./newWorkOrder.vue?vue&type=template&id=e36dcaaa&"
import script from "./newWorkOrder.vue?vue&type=script&lang=ts&"
export * from "./newWorkOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports